import { PartialAvailabilityInfo } from './types';

export const defaultSoonestAvailable: PartialAvailabilityInfo = {
  activityType: undefined,
  asSoonAsText: undefined,
  daysToAvailability: undefined,
  routeId: undefined,
  utcSoonestDateTimeIso: undefined
};

export const TWO_HOURS = 7200;

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const daysWithUniqueFormat = {
  '1': 'st',
  '2': 'nd',
  '3': 'rd'
};

export enum DaysRange {
  SameDayDelivery,
  UnderFourDays,
  Tomorrow,
  OverFourDays,
  Unknown
}
